import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { login } from '../../store/actions/auth'

function LoginForm({ auth, login, formObj, emailHandler, setFormObj, onChangeHandler }) {
  const { state, email, password, emailStatus } = formObj
  const history = useHistory()

  const onSubmitHandler = (e) => {
    e.preventDefault()
    login(formObj, setFormObj)
  }

  useEffect(() => {
    setFormObj((data) => ({ ...data, state: 'idle' }))
    if (auth.token) history.push(`/login?token=${auth.token}`)
  }, [auth, history, setFormObj])

  return (
    <form onSubmit={onSubmitHandler}>
      <div className='form-header'>LOGIN</div>
      <div className='mb-3 mt-4'>
        <input
          type='email'
          className={`form-control py-2 ${emailStatus}`}
          id='email'
          name='email'
          value={email}
          onChange={emailHandler}
          placeholder='example@xebia.com'
          required={true}
        />
      </div>
      <div className='mb-3 mt-4'>
        <input
          type='password'
          className={`form-control py-2`}
          id='password'
          name='password'
          value={password}
          onChange={onChangeHandler}
          placeholder='Enter your password'
          required={true}
        />
      </div>
      <button
        className={`btn btn-${state === 'submitted' ? 'success' : 'login-button'} px-4 py-2 mt-4`}
        disabled={state !== 'idle'}
        type='submit'>
        {state === 'submitting' && <div id='loading'></div>}
        {state === 'idle' && 'Login'}
        {state === 'submitted' && 'Login Successful'}
      </button>
    </form>
  )
}

const mapStateToProps = ({ auth }) => ({ auth })
export default connect(mapStateToProps, { login })(LoginForm)
